import React from 'react';
import './Hero.css';
import { FiGithub, FiLinkedin, FiMail, FiMapPin } from 'react-icons/fi';
import { FaFigma } from 'react-icons/fa';
import { useLanguage } from '../../i18n/LanguageContext';
import imgJereminth1 from '../../../assets/hero/fotoPerfil.png';

const socialLinks = [
  {
    id: 'github',
    icon: FiGithub,
    url: 'https://github.com/SamyuMT',
    title: 'GitHub'
  },
  {
    id: 'figma',
    icon: FaFigma,
    url: 'figma.com/@sammt1',
    title: 'Figma'
  },
  {
    id: 'linkedin',
    icon: FiLinkedin,
    url: 'https://www.linkedin.com/in/jereminth-mu%C3%B1oz-de-la-torre/',
    title: 'LinkedIn'
  },

  {
    id: 'email',
    icon: FiMail,
    url: 'mailto:jemycraft12@hotmail.com',
    title: 'Email'
  }
];

const Hero = () => {
  const { t } = useLanguage();

  return (
    <section className="hero" data-name="Hero" data-node-id="5:413">
      <div className="hero__container" data-name="Container" data-node-id="5:414">
        {/* Left Column */}
        <div className="hero__column hero__column--left" data-name="Column" data-node-id="5:415">
          {/* Content */}
          <div className="hero__content" data-name="Content" data-node-id="5:416">
            <h1 className="hero__title" data-node-id="5:417">
              {t('hero.greeting')}
            </h1>
            <p className="hero__description" data-node-id="5:418">
              {t('hero.description')}
            </p>
          </div>

          {/* Info */}
          <div className="hero__info" data-name="Group" data-node-id="5:419">
            {/* Location */}
            <div className="hero__info-item hero__info-item--location" data-name="Location" data-node-id="5:420">
              <div className="hero__info-icon" data-name="Icon" data-node-id="5:421">
                <FiMapPin size={24} color="#4b5563" />
              </div>
              <p className="hero__info-text">{t('hero.location')}</p>
            </div>

            {/* Available */}
            <div className="hero__info-item hero__info-item--available" data-name="Hire" data-node-id="5:423">
              <div className="hero__info-icon hero__info-icon--dot" data-name="Icon" data-node-id="5:424">
                <span className="hero__info-dot" data-name="icon-dot-emerald-500" data-node-id="5:425"></span>
              </div>
              <p className="hero__info-text">{t('hero.available')}</p>
            </div>
          </div>

          {/* Social Links */}
          <div className="hero__actions" data-name="Actions" data-node-id="5:427">
            <div className="hero__social-links" data-name="Links" data-node-id="5:428">
              {socialLinks.map((social) => {
                const IconComponent = social.icon;
                return (
                  <a
                    key={social.id}
                    href={social.url}
                    className="hero__social-btn"
                    title={social.title}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <IconComponent size={24} color="#4b5563" />
                  </a>
                );
              })}
            </div>
          </div>
        </div>

        {/* Right Column */}
        <div className="hero__column hero__column--right" data-name="Column" data-node-id="5:432">
          <div className="hero__pic-container" data-name="Pic Container" data-node-id="5:433">
            <div className="hero__pic-background" data-name="Background" data-node-id="5:434"></div>
            <div className="hero__pic" data-name="Pic" data-node-id="5:435">
              <img src={imgJereminth1} alt="Jereminth" className="hero__pic-img" data-node-id="10:778" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
